import { begin, end, span } from '../defs-js/time'

const hourString = (hour) => ('0' + hour).substr(-2) + ':00'

/**
 * 予約時間区分のリストを返す
 * @return {Array}
 */
export default function getNewDailySchedule () {
	const divs = []
	for (let t = begin; t < end; t = t + span) {
		divs.push({
			index: divs.length,
			fromHour: t,
			from: hourString(t),
			to: hourString(t + 1),
			isActive: false
		})
	}
	return divs
}
